module.exports = {
  patients: 'Pacjenci',
  couples: 'Pary',
  groups: 'Grupy',
  back: 'Cofnij',
  meeting: 'Spotkanie',
}
